import { Flex, Text } from '@chakra-ui/react'
import styled from 'styled-components'

const Button = styled.button`
  background-color: #fa0069;
  color: #fefefe;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  font-size: 16px;
  padding: 8px 16px;
  margin-top: 16px;
`

export const Done = () => {
  return (
    <Flex h="100vh" align="center" justify="center" direction="column" background="#0c0c0c">
      <img src="/img/logo.png" className="mx-auto" />
      <Text color="white">Video quiz concluído!</Text>
      <a href="/video-quiz">
        <Button>Clique aqui para recomeçar</Button>
      </a>
    </Flex>
  )
}
